
  import * as siteRuntime$eeUMPijBYPkBboBQOQdeqggX26QQh2V_45D8oI8B_33SA from '/app/image-providers/site.js'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "site",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['site']: { provider: siteRuntime$eeUMPijBYPkBboBQOQdeqggX26QQh2V_45D8oI8B_33SA, defaults: {"baseURL":"https://p-car.ukravto.ua"} }
    }
  }
